import { render } from "./LinkBuilderPartners.vue?vue&type=template&id=7cfc1b71"
import script from "./LinkBuilderPartners.vue?vue&type=script&lang=js"
export * from "./LinkBuilderPartners.vue?vue&type=script&lang=js"

import "./LinkBuilderPartners.vue?vue&type=style&index=0&id=7cfc1b71&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__